import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/**
 * Confirmation body for leaving the report builder/results view with unsaved
 * criteria changes. Purely informational — the Cancel/Discard actions live in
 * the surrounding {@link ModalConfig.actionButtons}, set up by the caller (see
 * `ReportBuilderComponent.confirmDiscardIfDirty` / `ReportResultsComponent`).
 */
@Component({
  selector: 'app-discard-changes-dialog',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './discard-changes-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './discard-changes-dialog.component.css',
})
export class DiscardChangesDialogComponent {}
